<template>
    <div>
        <nav  class="navbar top-toolbar navbar-default navbar-fixed-top text-center">
            <div class="container-fluid">
	        <ul class="nav navbar-nav navbar-left">
	            <li>
                        <button class="btn btn-icon sidebar-toggler" @click="toggleSidebar">
                            <i class="fa fa-lg fa-bars"></i>
                        </button>
                    </li>
                </ul>

	        <slot name="toolbar_buttons"></slot>

                <ul class="nav navbar-nav navbar-right">
                    <li class="dropdown" :class="{open: isTimezonesMenuOpen}">
                        <button class="btn dropdown-toggle" @click="isTimezonesMenuOpen = !isTimezonesMenuOpen">
                            <i class="fa fa-clock-o"></i> {{ userData.timezone }}
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right">
                            <li>
                                <FormulateInput type="search" @input="getTimezones" v-model="timezoneQuery" />
                            </li>
                            <li role="separator" class="divider"></li>
                            <li class="dropdown-timezones">
                                <ul>
                                    <li v-for="t in timezones">
                                        <button class="btn btn-link" @click="setTimezone(t)" :disabled="t == userData.timezone">
                                            <i v-if="t == userData.timezone" class="fa fa-check" aria-hidden="true"></i> {{ t }}
                                        </button>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="dropdown profile" v-bind:class="{open: isMenuOpen}">
                        <button class="btn dropdown-toggle" @click="isMenuOpen = !isMenuOpen">
                            <i class="fa fa-cog" aria-hidden="true"></i>  {{ activeAccount.name }}
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right">
                            <li>
		                <router-link to="/settings/profile">
                                    <i class="fa fa-user" aria-hidden="true"></i> {{  userData.email }}
		                </router-link>
                            </li>
                            <li v-if="is_admin">
		                <router-link to="/settings/account">
                                    <i class="fa fa-cog" aria-hidden="true"></i> Settings
		                </router-link>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
		                <a v-on:click="logout()" role="button">
                                    <i class="fa fa-sign-out" aria-hidden="true"></i> Logout
		                </a
                            </li>
                            <li v-if="userData.accounts.length > 1" role="separator" class="divider"></li>
                            <li v-if="userData.accounts.length > 1" class="account-switcher-wrapper">
                                <FormulateInput id="account-switcher-search" type="search" v-model="accountFilter" />
                                <ul class="accounts-menu">
                                    <li v-if="customers.length" class="role-title">Customers</li>
                                    <li v-for="a in customers">
                                        <a v-on:click="switchAccount(a)" href="#">
                                            <i v-if="a.active == true" class="fa fa-check" aria-hidden="true"></i> {{ a.name }}</a>
                                    </li>
                                    <li v-if="vendors.length" role="separator" class="divider"></li>
                                    <li class="role-title" v-if="vendors.length">Vendors</li>
                                    <li v-for="a in vendors">
                                        <a v-on:click="switchAccount(a)" href="#">
                                            <i v-if="a.active == true" class="fa fa-check" aria-hidden="true"></i> {{ a.name }}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
	        </ul>
            </div>
        </nav>
        <div class="section-content container-fluid" id="main-container">
            <div class="row">
	        <slot class="col-xs-12 main" name="main"></slot>
            </div>
        </div>
        <slot name="modals"></slot>
    </div>
</template>

<script>

     var _ = require('lodash');


export default {
     components: {
     },
     data () {
         return {
             timezoneQuery: "",
             is_admin: false,
             userData: {
                 id: null,
                 username: null,
                 email: null,
                 first_name: null,
                 last_name: null,
                 accounts: [],
                 role: null,
                 timezone: null
             },
             isMenuOpen: false,
             isTimezonesMenuOpen: false,
             showDashboardModal: false,
             showLeadsQueueModal: false,
             accountFilter: "",
             timezones: []
     }},
     computed: {
         activeAccount: function () {
             var active = this.userData.accounts.filter(function (item) {
                 return item.active;
             });

             if (active.length > 0) {
		           return active[0];
             }
             return null;
         },
         vendors: function () {
             var self = this;
             return this.userData.accounts.filter(
                 (account) =>
                     (account.account_type == 'vendor') && (self.accountFilter.trim() ? account.name.toLowerCase().indexOf(self.accountFilter.trim().toLowerCase()) > -1 : true))
         },
         customers: function () {
             var self = this;
             return this.userData.accounts.filter(
                 (account) =>
                     (account.account_type == 'customer') && (self.accountFilter.trim() ? account.name.toLowerCase().indexOf(self.accountFilter.trim().toLowerCase()) > -1 : true))
         },
     },
     created () {
         this.userData = this.$store.state.user;
         if (this.userData == null) {
             Vue.router.push({name: 'login'});
         }
         this.is_admin = this.userData.role == "superuser";

         if (this.userData.timezone == null) {
             let localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
             this.setTimezone(localTimezone);
         }

         this.getTimezones();
     },
     methods: {
         getTimezones: _.debounce(function () {
             var self = this;
             API.timezones.getList(self.timezoneQuery)
                .then((response) => {
                    this.timezones = response.data;
                });
         }, 100),
         setTimezone(timezone) {
             var self = this;
             API.user.setTimezone(timezone)
                .then((response) => {
                    self.$store.commit('setUser', response.body);
                    window.location.reload();

                });
         },
         switchAccount (account) {
             var self = this;
             var permission = {'ok': true};
             BUS.$emit('canISwitchAccount', permission);
             this.$nextTick(() => {
                 if (permission.ok) {
                     self.$store.dispatch('switchAccount', account)
                         .then(() => { window.location.reload(); });
                 }
                 else {
                     this.toggleMenu();
                 }
             });
         },
         toggleSidebar () {
             BUS.$emit('toggleSidebar')
         },
         logout () {
             var self = this;
             self.$store
                 .dispatch('logout')
                 .then(() => {
                     self.$router.push({name: 'login'})
                 });
         },
     }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// BaseLayout.vue?bbf0bc90